import React, { FC } from 'react';

export const DocumentsIcon: FC<any> = ({ size = 17, stroke = '#fff', ...props }) => (
  <svg {...props} height={size} viewBox="0 0 16.929 18.857" width={size} xmlns="http://www.w3.org/2000/svg">
    <path
      d="m55.857 294.857v7.714a1.928 1.928 0 0 0 1.929 1.929h5.786m-7.714-9.643v-1.929a1.928 1.928 0 0 1 1.928-1.928h4.422a.963.963 0 0 1 .682.283l4.257 4.256a.965.965 0 0 1 .282.682v6.351a1.928 1.928 0 0 1 -1.929 1.928h-1.928m-7.714-9.643h-1.929a1.928 1.928 0 0 0 -1.929 1.929v9.643a1.928 1.928 0 0 0 1.929 1.929h7.714a1.928 1.928 0 0 0 1.929-1.929v-1.929"
      fill="none"
      stroke={stroke}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      transform="translate(-51.25 -290.25)"
    />
  </svg>
);
